import { Intent } from '@applyboard/ui-icons';

export const DEFAULT_SORT_ORDER = [{ id: 'created_date', desc: true }];
export const DEFAULT_PAGE_SIZE = 10;

export const TAG_INTENT: Record<string, Intent> = {
  ['UnderReview']: 'secondary',
  ['DocumentIssued']: 'positive',
  ['AccountOpened']: 'primary',
  ['RPCommissionPaid']: 'magic',
  ['Refunded']: 'magic',
  ['Cancelled']: 'negative',
};

export const TAB_NAME = 'GIC Applications';

export const ALL_TAB = 'ALL GIC Applications';
export const RBC_TAB = 'RBC';
export const TD_TAB = 'TD';

export const GIC_STATUS_OPTIONS_LIST = [
  { value: 'UnderReview', label: 'Under Review' },
  { value: 'DocumentIssued', label: 'Document Issued' },
  { value: 'AccountOpened', label: 'Account Opened' },
  { value: 'RPCommissionPaid', label: 'RP Commission Paid' },
  { value: 'Refunded', label: 'Refunded' },
  { value: 'Cancelled', label: 'Cancelled' },
];

export const GIC_STATUS_VALUES = GIC_STATUS_OPTIONS_LIST.map(
  option => option.value,
) as unknown as readonly [string, ...string[]];
